import React from "react";
import { Link } from "react-router-dom";
import downArrow from "../assets/downArrow.png";

const Copyright = () => {
  return (
    <div className="bg-black text-white min-h-screen flex flex-col items-center px-8 py-10">
      {/* Back Button */}
      {/* <div className="absolute top-5 left-5">
        <Link to="/" className="text-white flex items-center space-x-2">
          <span className="text-2xl">&larr;</span>
          <span className="text-white">Back</span>
        </Link>
      </div> */}

      {/* Title */}
      <h1 className="text-primary text-4xl font-bold mb-2">Copyright Notice</h1>
      <div className="flex justify-center">
        <img src={downArrow} alt="Arrow Down" className="h-7  mt-6 mb-6" />
      </div>
      {/* Content */}
      <div className="max-w-4xl space-y-6 text-left">
        {/* Respect for Intellectual Property */}
        <section>
          <p>
            Futcoinspot respects the intellectual property rights of others and expects users of our services to do the same. If you believe that your copyrighted work has been infringed in a manner that violates your rights and is accessible through a website or service operated by us, you may notify us in accordance with the Digital Millennium Copyright Act of 1998 (DMCA) or other applicable copyright laws.
          </p>
        </section>

        {/* Notice of Claimed Infringement */}
        <section>
          <h2 className="text-primary text-2xl font-semibold mb-2">
            Notice of Claimed Infringement
          </h2>
          <p>
            To report a claimed infringement, please send a written communication that includes the following information:
          </p>
          <ul className="list-disc list-inside space-y-2 mt-2">
            <li>
              A physical or electronic signature of a person authorized to act on behalf of the copyright owner.
            </li>
            <li>
              Identification of the copyrighted work that you claim has been infringed.
            </li>
            <li>
              Identification of the material that is claimed to be infringing or the subject of infringing activity, and information reasonably sufficient to enable us to locate the material.
            </li>
            <li>Your contact information, such as an email address or telephone number.</li>
            <li>
              A statement that you have a good faith belief that the use of the material in the manner complained of is not authorized by the copyright owner, its agent, or the law.
            </li>
            <li>
              A statement that the information in the notification is accurate, and under penalty of perjury, that you are authorized to act on behalf of the owner of an exclusive right which is allegedly infringed.
            </li>
          </ul>
        </section>

        {/* DMCA Counter Notification */}
        <section>
          <h2 className="text-primary text-2xl font-semibold mb-2">
            DMCA Counter Notification
          </h2>
          <p>
            If you receive a notification stating that material you submitted to Futcoinspot is disabled or removed as a result of a DMCA Notice, and you believe that the material was disabled or removed as a result of mistake or misidentification, you may send us a DMCA Counter-Notification. You need to send us a notification that includes the following:
          </p>
          <ul className="list-disc list-inside space-y-2 mt-2">
            <li>Your physical or electronic signature.</li>
            <li>
              Identification of the material that has been removed or to which access has been disabled and the location at which the material appeared before it was removed or access to it was disabled.
            </li>
            <li>
              A statement, under penalty of perjury, that you have a good faith belief that the material was removed or disabled as a result of mistake or misidentification.
            </li>
            <li>Your name, address, telephone number, and e-mail address.</li>
            <li>
              A statement that you consent to the jurisdiction of the Federal District Court for the judicial district in which you are located, or if your address is outside of the United States, of any judicial district in which we do business.
            </li>
          </ul>
        </section>

        {/* Futcoinspot Statement */}
        <section>
          <h2 className="text-primary text-2xl font-semibold mb-2">
            Futcoinspot Statement
          </h2>
          <p>
            Futcoinspot has long been committed to providing convenient and legal trading services. Meanwhile, we respect and protect the intellectual copyright rights of related parties. We always resolutely put an end to infringements that harm the legitimate interests of others, and implement this principle in our daily services and operations.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Copyright;
